// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination--1lwXzPsG-X","loader":"loader--2dcZXzHYef","display":"display--2Swvl7Ue1Y","inputContainer":"inputContainer--2DU5dR47bA"};